import queryString from 'query-string';
import { useSelector } from 'react-redux';

import makeSelectApplicantsV2 from 'containers/ApplicantsV2/selectors';

// The job table keeps its search in the store; only the master view mirrors it into the URL `query` param.
export default function useBulkSearchTerm(
  isMasterApplicantsView: boolean | undefined,
  urlSearch = '',
): string | undefined {
  const { searchQuery } = useSelector(makeSelectApplicantsV2());
  const term = isMasterApplicantsView
    ? queryString.parse(urlSearch).query
    : searchQuery;
  return typeof term === 'string' && term ? term : undefined;
}
